export default {
    page_title: "Kevi | Lista de Cupons",
    title: "Cupons",
    export_aria_label: "Exportar cupons",
    export_button: "Exportar",
    table: {
        coupon: "Cupom",
        client: "Cliente",
        phone: "Telefone",
        email: "E-mail",
        created_at: "Data de Criação",
        validity_between: "Validade Entre",
        used_at: "Usado em",
        automation: "Automação",
    },
    badges: {
        used: "Utilizado:",
        expired: "Vencido",
        valid_until: "Válido até",
    },
    empty: {
        no_name: "Nome não informado",
        not_used: "Não utilizado",
        no_automation: "Criado sem automação",
        no_data_for_period: "Sem dados para o período",
    },
    filters: {
        client_segment: "Segmento do cliente",
        coupon_code: "Código do cupom",
        created_date: "Data de criação",
        expiration_date: "Data de validade",
        used_date: "Data de uso",
        automation: "Automação",
        status: "Situação",
        available: "Disponível",
        used: "Utilizado",
        expired: "Vencido",
    },
    export: {
        status_before_validity: "Antes da Validade",
        status_used: "Utilizado",
        status_expired: "Expirado",
        status_valid: "Válido",
        column_code: "Código",
        column_coupon: "Cupom",
        column_status: "Situação",
        column_valid_from: "Início da Validade",
        column_valid_until: "Fim da Validade",
        column_used_at: "Usado em",
        column_client_name: "Nome do Cliente",
        column_client_phone: "Telefone do Cliente",
        column_client_email: "E-mail do Cliente",
        column_automation: "Automação",
    },
    conjunction_and: "e",
};
